import React from "react";

export default function ExploreServices() {
  return (
    <section id="expore-services">
      <div className="container py-10">
        {/* heading and top info */}
        <div className="space-y-5 text-left">
          <h1 className="text-black font-bold text-3xl w-96">
            Explore our financial solutions below
          </h1>
          <p className="text-gray-600">
            At TPS we work closely with banks and financial services clients,
            ensuring they have the secure, compliant IT solutions they need to
            achieve their business goals, as well as providing excellent
            ongoing support.
          </p>
        </div>

        {/* service items */}
        <div className="grid mt-10 md:mt-20 gap-4 md:grid-cols-3">
          {/* item 1 */}
          <div className="border-2 space-y-5 border-blue-100 p-5 md:p-10 rounded">
            <h1 className="text-black text-2xl font-semibold">
              Regulatory compliance &amp; security
            </h1>
            <p className="text-gray-500 text-left">
              We help financial businesses meet FCA, PCI DSS and GDPR
              requirements with hardened infrastructure, access controls and
              audit-ready reporting, reducing regulatory risk while keeping
              your operations running smoothly.
            </p>
          </div>

          {/* item 2 */}
          <div className="border-2 space-y-5 border-blue-100 p-5 md:p-10 rounded">
            <h1 className="text-black text-2xl font-semibold">
              Secure transaction infrastructure
            </h1>
            <p className="text-gray-500 text-left">
              From encrypted payment processing to secure data storage, our
              infrastructure is built to protect sensitive financial data at
              every step, giving your customers confidence and your business
              peace of mind.
            </p>
          </div>

          {/* item 3 */}
          <div className="border-2 space-y-5 border-blue-100 p-5 md:p-10 rounded">
            <h1 className="text-black text-2xl font-semibold">
              Business continuity &amp; disaster recovery
            </h1>
            <p className="text-gray-500 text-left">
              Financial institutions cannot afford downtime. Our disaster
              recovery and business continuity solutions keep your core
              banking systems and customer services available, even when the
              unexpected happens.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
